import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { AppShell } from '@/components/layout/AppShell';
import { RouteError } from '@/features/system/RouteError';
import { authRoutes } from '@/features/auth/routes';
import { backofficeRoutes } from '@/features/backoffice/routes';
import { campaignRoutes } from '@/features/campaigns/routes';
import { courseRoutes } from '@/features/courses/routes';
import { libraryRoutes } from '@/features/library/routes';
import { paymentRoutes } from '@/features/payments/routes';
import { profileRoutes } from '@/features/profile/routes';
import { workforceRoutes } from '@/features/workforce/routes';
import { zakatRoutes } from '@/features/zakat/routes';

/** Chaque module déclare ses routes en chargement différé (code splitting par module). */
const moduleRoutes: RouteObject[] = [
  ...authRoutes,
  ...profileRoutes,
  ...zakatRoutes,
  ...paymentRoutes,
  ...campaignRoutes,
  ...libraryRoutes,
  ...courseRoutes,
  ...workforceRoutes,
  ...backofficeRoutes,
];

/** Les routes `admin/*` (hors connexion) sont rendues dans le gabarit du back-office. */
const isAdmin = (r: RouteObject) => Boolean(r.path && /^\/?admin(\/|$)/.test(r.path) && !/^\/?admin\/connexion/.test(r.path));

const routes: RouteObject[] = [
  {
    element: <AdminLayout />,
    errorElement: <RouteError />,
    children: moduleRoutes.filter(isAdmin),
  },
  {
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, lazy: () => import('@/features/home/HomePage').then((m) => ({ Component: m.HomePage })) },
      ...moduleRoutes.filter((r) => !isAdmin(r)),
      { path: 'offline', lazy: () => import('@/features/system/OfflinePage').then((m) => ({ Component: m.OfflinePage })) },
      { path: '*', lazy: () => import('@/features/system/NotFoundPage').then((m) => ({ Component: m.NotFoundPage })) },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  future: { v7_relativeSplatPath: true, v7_fetcherPersist: true, v7_normalizeFormMethod: true, v7_partialHydration: true, v7_skipActionErrorRevalidation: true },
});
